<template>
	<div class="youtube">
		<div id="player" style="width: 100%; height: 400px;"></div>
	</div>
</template>

<script>
	export default {
    props: {
      id: {
        type: String,
        required: true,
      },
      onPlaying: {
        type: Function,
        default: () => {}
      },
      onPaused: {
        type: Function,
        default: () => {}
      },
      onBuffer: {
        type: Function,
        default: () => {}
      },
      onEnded: {
        type: Function,
        default: () => {}
      },
    },

    mounted() {
      this.init()
    },

    beforeDestroy() {
      if (!this.isEmpty(this.player)) {
        this.player.destroy();
      }
    },

		data() {
			return {
        player: null,
				videoTitle: '',
				duration: '',
        youtube_tag_id: 'youtube-script'
			}
    },

    methods: {
      init() {
        const vm = this;

        if ($(`#${vm.youtube_tag_id}`).length <= 0) {
          var tag = document.createElement('script');

          tag.id = vm.youtube_tag_id;
          tag.src = "https://www.youtube.com/iframe_api";
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          window.onYouTubeIframeAPIReady = function() {
            vm.setPlayer();
          }
        } else {
          vm.setPlayer();
        }
      },
      setPlayer() {
        const vm = this
        vm.player = new YT.Player('player', {
          videoId: vm.id,
          playerVars: {
            autoplay: 0
          },
          events: {
            'onReady': vm.onPlayerReady,
            'onStateChange': vm.onPlayerStateChange
          }
        });
      },
      onPlayerReady(e) {
        // e.target.playVideo();
      },
      onPlayerStateChange(e) {
        const vm = this;

        let duration = vm.player.getDuration()

        switch (e.data) {
          case 0:
            this.onEnded(e.target, duration);
            break;
          case 1:
            this.onPlaying(e.target, duration);
            break;
          case 2:
            this.onPaused(e.target, duration);
            break;
          case 3:
            this.onBuffer(e.target, duration);
            break;
        }
      }
    }
	}
</script>
